export default __webpack_public_path__ + "media/95f1c06222559df4a76347a63962fbb002ab586d4fcd34fb4d7ab830949aa92f.svg";